import React, { useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { Link, useNavigate, useParams } from 'react-router-dom';
import yup from '../../libs/yup/yup';
import { yupResolver } from '@hookform/resolvers/yup';
import TextInput from '../../components/form/TextInput';
import Swal from 'sweetalert2';
import { getTenantCostDetail, updateTenantCost } from '../../api/sportaloka-client';

const defaultValues = {
  description: '',
  amount: 0
};

const schema = yup.object().shape({
  description: yup.string().label('Deskripsi').required('${label} wajib diisi'),
  amount: yup
    .number('${label} harus berupa angka')
    .label('Nilai Biaya')
    .typeError('Harus berupa angka')
    .required('${label} wajib diisi')
});

const DetailTenantCost = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [initLoading, setInitLoading] = useState(false);
  const [initError, setInitError] = useState(false);

  const form = useForm({
    defaultValues,
    mode: 'onChange',
    resolver: yupResolver(schema)
  });

  const onSubmit = async (val) => {
    try {
      setLoading(true);
      await updateTenantCost(id, val);
      navigate('/tenant-costs');
      Swal.fire({
        title: 'Berhasil!',
        text: `Biaya berhasil diubah`,
        icon: 'success',
        confirmButtonText: 'Tutup'
      });
      setLoading(false);
    } catch (error) {
      let message = 'Periksa koneksi internet anda dan coba kembali';

      Swal.fire({
        title: 'Gagal!',
        text: message,
        icon: 'error',
        confirmButtonText: 'Tutup'
      });
      setLoading(false);
    }
  };

  const getData = async () => {
    try {
      setInitError(false);
      setInitLoading(true);
      const response = await getTenantCostDetail(id);
      const responseData = response.data.data;
      form.setValue('description', responseData.description);
      form.setValue('amount', responseData.amount);
      setInitLoading(false);
    } catch (error) {
      setInitError(true);
      setInitLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <form onSubmit={form.handleSubmit(onSubmit)}>
      <div className="row y-gap-20 justify-between items-end pb-60 lg:pb-40 md:pb-32">
        <div className="col-12">
          <div className="d-flex justify-content-between align-items-center">
            <h1 className="text-30 lh-14 fw-600">Detail Master Biaya</h1>
            {!initLoading && (
              <div className="d-flex">
                <Link to="/tenant-costs" className="button -md bg-white h-50 text-dark mr-20">
                  <i className="fa fa-arrow-left mr-10" />
                  Kembali
                </Link>

                <button disabled={loading} className="button -md bg-blue-1 h-50 text-white">
                  {!loading && <i className="fa fa-save text-16 mr-10" />}
                  {loading ? 'Menyimpan...' : 'Simpan'}
                </button>
              </div>
            )}
          </div>
          <div className="py-30 px-30 rounded-4 bg-white shadow-3 mt-20 d-flex align-items-center justify-content-center">
            {initLoading && !initError && (
              <div className="d-flex justify-content-center align-items-center h-100">
                <p className="fw-500 text-dark my-auto">Memuat...</p>
              </div>
            )}
            {!initLoading && initError && (
              <div className="d-flex justify-content-center align-items-center h-100">
                <p className="fw-500 text-dark my-auto text-center">
                  Tidak dapat melakukan permintaan, periksa koneksi internet anda dan{' '}
                  <p className="text-danger fw-600 cursor-pointer" onClick={getData}>
                    coba kembali
                  </p>
                </p>
              </div>
            )}
            {!initLoading && !initError && (
              <div className="row w-100">
                <div className="col-12">
                  <Controller
                    control={form.control}
                    name="description"
                    render={({ field: { onChange, onBlur, value } }) => (
                      <TextInput
                        disabled={loading}
                        onChange={onChange}
                        onBlur={onBlur}
                        value={value}
                        type="text"
                        isRequired={true}
                        label="Deskripsi"
                        isError={Boolean(form.formState.errors.description)}
                        errorMessage={
                          Boolean(form.formState.errors.description) &&
                          form.formState.errors.description.message
                        }
                      />
                    )}
                  />
                </div>
                <div className="col-6">
                  <Controller
                    control={form.control}
                    name="amount"
                    render={({ field: { onChange, onBlur, value } }) => (
                      <TextInput
                        disabled={loading}
                        onChange={onChange}
                        onBlur={onBlur}
                        value={value}
                        type="number"
                        isRequired={true}
                        label={'Nilai Biaya'}
                        isError={Boolean(form.formState.errors.amount)}
                        errorMessage={
                          Boolean(form.formState.errors.amount) &&
                          form.formState.errors.amount.message
                        }
                      />
                    )}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </form>
  );
};

export default DetailTenantCost;
